export default __webpack_public_path__ + "static/media/Banned.83bb2d51.webp";